import { render } from "./Urne.vue?vue&type=template&id=620f0513"
import script from "./Urne.vue?vue&type=script&lang=js"
export * from "./Urne.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__